// Small module-level cache for assets that the verified HTML report wants but
// that are rendered on a DIFFERENT tab (so they aren't in the DOM when the user
// exports from the Comparison tab). The Video Analysis tab captures its diagram
// here while it is visible; the HTML export reads it back.
//
// The html2canvas capture lives here (in the webclient, which owns the
// dependency) so the app only needs to hand over the DOM element.
import html2canvas from "html2canvas";

let analysisGraphImage: string | undefined;

export const reportAssets = {
  get analysisGraphImage(): string | undefined {
    return analysisGraphImage;
  },
  setAnalysisGraphImage(dataUrl?: string): void {
    analysisGraphImage = dataUrl;
  },
  clear(): void {
    analysisGraphImage = undefined;
  },
  // Best-effort: rasterise the given element and cache it for the HTML report.
  async captureAnalysisGraph(element: HTMLElement): Promise<void> {
    // The diagram is mounted only while the ORIGINAL analysis output is on screen, so it goes
    // away the moment the reviewer switches to the approved list -- and the switch can also be
    // made for them (accepting comparison rows lands on that tab). html2canvas clones from the
    // document root and finds its target by walking the clone, so a detached element is never
    // reached and the cloner throws. Not starting is the only reliable guard: nothing can be
    // captured from a node that has left the page.
    if (!element.isConnected) return;

    try {
      const canvas = await html2canvas(element, {
        backgroundColor: "#ffffff",
        logging: false,
        useCORS: true,
      });
      analysisGraphImage = canvas.toDataURL("image/png");
    } catch {
      /* leave the report without the graph */
    }
  },
};
